import React from "react";
import "./corebusiness.css";
import { Link } from "react-router";
import coreImg1 from "../../Media/Photos Gallery/clientcentered.jpeg";
import coreImg2 from "../../Media/Photos Gallery/craftmanship.png";
import coreImg3 from "../../Media/Photos Gallery/gallery.png";

export default function CoreBusiness() {
  return (
    <div className="corebusiness">
      <h6>Our Core BUisness</h6>
      <h3>Offering a unique and stylish perspective on fashion.</h3>

      <div className="business-boxes">
        <div className="business-box">
          <img src={coreImg2} alt="business" loading="lazy" decoding="async" />
          <div className="business-texts">
            <h3>Craftsmanship First</h3>
            <p>
              We pride ourselves on precision and detail. Every garment is
              constructed with care, using premium materials and expert
              techniques to ensure lasting quality and timeless design.
            </p>
            <Link to="/services">
              <button>KNOW MORE</button>
            </Link>
          </div>
        </div>
        <div className="business-box">
          <img
            src={coreImg1}
            alt="business"
            loading="lazy"
            decoding="async"
            style={{
              objectFit: "cover",
              objectPosition: "top",
            }}
          />
          <div className="business-texts">
            <h3>Client-Centered Design</h3>
            <p>
              At the heart of our work is you. We listen, collaborate, and
              refine—ensuring every creation not only meets but exceeds your
              expectations. Your satisfaction is our measure of success.
            </p>
            <Link to="/services">
              <button>KNOW MORE</button>
            </Link>
          </div>
        </div>
        <div className="business-box">
          <img src={coreImg3} alt="business" loading="lazy" decoding="async" />
          <div className="business-texts">
            <h3>Sustainable Values</h3>
            <p>
              We are committed to ethical practices. From responsible sourcing
              to minimal-waste production methods, we create with
              purpose—reducing environmental impact while elevating design.
            </p>
            <Link to="/services">
              <button>KNOW MORE</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
